import React from "react";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import AnyQuestions from "../../reusable/AnyQuestions";
import BuySubNavi from "./BuySubNavi";
import PurchaseDeviceCart from "./PurchaseDeviceCart";
import PurchaseDeviceBanner from "../../reusable/PurchaseDeviceBanner";
import {PulseLoader} from "react-spinners";
import Checkout from "../checkout";
import LoginPage from "../login";
import {connect} from "react-redux";

class PurchaseDevice extends React.Component {
    constructor(props) {
        super(props);
    }

    render(){
        const { auth } = this.props;
        //if (typeof this.props.location.state !== "undefined" && typeof this.props.location.state.promotion !== "undefined") {
        if (typeof this.props.location.state !== "undefined" &&
            typeof this.props.location.state.promotion !== "undefined" &&
            typeof this.props.location.state.buy_option !== "undefined" &&
            typeof this.props.location.state.useType !== "undefined") {
            if (auth.isAuthenticated) {
                if(typeof this.props.cart.cart !== 'undefined' && typeof this.props.cart.cart.product !== 'undefined') {
                    //this.props.cart.cart.product.image = "/images/mightywifi-cloud-" + this.props.location.state.color.toLowerCase() + ".png";
                    this.props.cart.cart.product.color = this.props.location.state.color;
                    this.props.cart.cart.color = this.props.location.state.color;
                }
                return (
                    <div>
                        <PulseLoader
                            className="sweet-loading"
                            sizeUnit={"px"}
                            size={20}
                            color={"#123abc"}
                            loading="true"
                        />
                        <Checkout/>
                        <PurchaseDeviceCart/>
                    </div>
                );
            }
            else {
                return (
                    <div>
                        <PulseLoader
                            className="sweet-loading"
                            sizeUnit={"px"}
                            size={20}
                            color={"#123abc"}
                            loading="true"
                        />
                        <LoginPage/>
                        <PurchaseDeviceCart/>
                    </div>
                );
            }
        }
        else {
            return (
                <div>
                    <PurchaseDeviceBanner/>
                    {/*<BuySubNavi/>*/}
                    <PurchaseDeviceCart/>
                    <AnyQuestions/>
                    <StayTouch/>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        auth: state.auth,
        cart: state.cart
    };
}

//export default layoutWrapper(PurchaseDevice);
//export default connect(mapStateToProps)(PurchaseDevice);
export default connect(mapStateToProps)(layoutWrapper(PurchaseDevice));



// WEBPACK FOOTER //
// ./src/pages/purchaseDevice/index.js